import handleError from 'common/helpers/handleError';
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('dashboard', ['createForm']),
    async openNewForm() {
      try {
        const guid = await this.createForm();
        await this.$router.push({
          name: ENUMS.ROUTES.FORM.INDEX,
          params: { guid },
        });
      } catch (error) {
        handleError(error);
      }
    },
  },
};
